// extracted by mini-css-extract-plugin
export default {"container":"ModifyPlanSettingsMagpie_container__tQmOg"};